inform.directive('inform', function () {
  return {
    restrict: 'AE',
    templateUrl: 'angular-inform/directive.ng.html',
    controller: 'InformCtrl'
  };
});